import { render, staticRenderFns } from "./addServiceProject.vue?vue&type=template&id=6980b073&scoped=true&"
import script from "./addServiceProject.vue?vue&type=script&lang=js&"
export * from "./addServiceProject.vue?vue&type=script&lang=js&"
import style0 from "./addServiceProject.vue?vue&type=style&index=0&id=6980b073&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980b073",
  null
  
)

component.options.__file = "addServiceProject.vue"
export default component.exports